<script setup lang="ts">
import * as icons from 'lucide-vue-next';
import { computed } from 'vue';

const props = withDefaults(defineProps<{ name: string; size?: number }>(), {
  size: 20,
});

const Icon = computed(() => (icons as any)[props.name] ?? icons.HelpCircle);
</script>

<template>
  <component :is="Icon" :size="size" :stroke-width="1.5" />
</template>
